export enum SubmitResultType {
  Reject = 'Reject',
  Pass = 'Pass',
}

export interface SubmitResult {
  type: SubmitResultType;
}
